__turbopack_context__.v({
  "cancel": "ChangeRoomDrawer-module__aE0jEG__cancel",
  "change-room-modal-loading-bar": "ChangeRoomDrawer-module__aE0jEG__change-room-modal-loading-bar",
  "dividerInset": "ChangeRoomDrawer-module__aE0jEG__dividerInset",
  "drawerBody": "ChangeRoomDrawer-module__aE0jEG__drawerBody",
  "drawerBodyModal": "ChangeRoomDrawer-module__aE0jEG__drawerBodyModal",
  "empty": "ChangeRoomDrawer-module__aE0jEG__empty",
  "emptyModal": "ChangeRoomDrawer-module__aE0jEG__emptyModal",
  "filtersDivider": "ChangeRoomDrawer-module__aE0jEG__filtersDivider",
  "filtersRow": "ChangeRoomDrawer-module__aE0jEG__filtersRow",
  "filtersRowModal": "ChangeRoomDrawer-module__aE0jEG__filtersRowModal",
  "footer": "ChangeRoomDrawer-module__aE0jEG__footer",
  "footerButtons": "ChangeRoomDrawer-module__aE0jEG__footerButtons",
  "footerButtonsModal": "ChangeRoomDrawer-module__aE0jEG__footerButtonsModal",
  "footerModal": "ChangeRoomDrawer-module__aE0jEG__footerModal",
  "heading": "ChangeRoomDrawer-module__aE0jEG__heading",
  "headingModal": "ChangeRoomDrawer-module__aE0jEG__headingModal",
  "list": "ChangeRoomDrawer-module__aE0jEG__list",
  "loadingBar": "ChangeRoomDrawer-module__aE0jEG__loadingBar",
  "modalContentLoading": "ChangeRoomDrawer-module__aE0jEG__modalContentLoading",
  "modalMain": "ChangeRoomDrawer-module__aE0jEG__modalMain",
  "resultsCount": "ChangeRoomDrawer-module__aE0jEG__resultsCount",
  "roomBoardBasis": "ChangeRoomDrawer-module__aE0jEG__roomBoardBasis",
  "roomInfo": "ChangeRoomDrawer-module__aE0jEG__roomInfo",
  "roomItem": "ChangeRoomDrawer-module__aE0jEG__roomItem",
  "roomName": "ChangeRoomDrawer-module__aE0jEG__roomName",
  "roomPrice": "ChangeRoomDrawer-module__aE0jEG__roomPrice",
  "scrollAreaModal": "ChangeRoomDrawer-module__aE0jEG__scrollAreaModal",
  "totalChange": "ChangeRoomDrawer-module__aE0jEG__totalChange",
  "totalChangeModal": "ChangeRoomDrawer-module__aE0jEG__totalChangeModal",
});
